import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { memo } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { BackdropUI } from './styles/input-control-styles';

function Backdrop(_ref) {
  let {
    disabled = false,
    isFocused = false
  } = _ref;
  return createElement(BackdropUI, {
    "aria-hidden": "true",
    className: "components-input-control__backdrop",
    disabled: disabled,
    isFocused: isFocused
  });
}

const MemoizedBackdrop = memo(Backdrop);
export default MemoizedBackdrop;
//# sourceMappingURL=backdrop.js.map